import { Skeleton } from "src/atoms/Skeleton";
import { Flex } from "@otrium/core";
import { GridSkeleton } from "src/organisms/ProductList/GridSkeleton";
import { SkeletonContainer } from "../ProductCategoryView.styled";
import {
  CategoryTreeWrapper,
  ListingContainer,
} from "../../ProductList/ProductList.styled";
import { theme } from "src/theme";

function ProductCategoryViewSkeleton(): JSX.Element {
  return (
    <SkeletonContainer>
      <Flex flexWrap="wrap" gap={theme.space.space4}>
        <Skeleton width="200px" height="20px" />
        <Skeleton width="45px" height="20px" />
        <Skeleton width="45px" height="20px" />
      </Flex>
      <Flex width="150px" height="35px">
        <Skeleton />
      </Flex>
      <ListingContainer>
        <CategoryTreeWrapper>
          <Flex
            as="ul"
            px={2}
            pl={4}
            flexDirection="column"
            gap={theme.space.space8}
          >
            {[...(Array(3) as number[])].map((_, index) => (
              <Flex as="li" key={`skeleton-line-${index}`}>
                <Skeleton height={theme.space.space24} />
              </Flex>
            ))}
          </Flex>
          <Flex
            as="ul"
            px={2}
            pl={4}
            flexDirection="column"
            gap={theme.space.space8}
          >
            {[...(Array(10) as number[])].map((_, index) => (
              <Flex
                as="li"
                key={`skeleton-line-${index}`}
                gap={theme.space.space8}
              >
                <Skeleton
                  width={theme.space.space24}
                  height={theme.space.space24}
                />
                <Skeleton width="100vw" height={theme.space.space24} />
              </Flex>
            ))}
          </Flex>
        </CategoryTreeWrapper>
        <Flex
          sx={{ gridColumn: "span 3" }}
          gap={theme.space.space24}
          flexDirection="column"
        >
          <Skeleton height={theme.space.space96} />
          <Skeleton height={theme.space.space64} />

          <Flex flexWrap="wrap" flexDirection="row" gap={theme.space.space8}>
            {[...(Array(8) as number[])].map((_value, index) => (
              <Skeleton
                key={`filter_${index}`}
                width={theme.space.space96}
                height={theme.space.space32}
              />
            ))}
          </Flex>

          <Flex width="300px" height={theme.space.space32} ml="auto">
            <Skeleton />
          </Flex>

          <GridSkeleton />
        </Flex>
      </ListingContainer>
    </SkeletonContainer>
  );
}

export { ProductCategoryViewSkeleton };
